import { State } from "@/store/modules/space/index";

const setSpace = (state: State, payload): void => {
  const rooms = state.space?.scenario?.rooms
    ? state.space.scenario.rooms
    : null;
  const featurePlan = state.space?.superSpace?.featurePlan
    ? state.space.superSpace.featurePlan
    : null;  
  state.space = payload;
  if (!payload.scenario.rooms && rooms) {
    state.space.scenario.rooms = rooms;
  }
  if (!payload.superSpace.featurePlan && featurePlan) {
    state.space.superSpace.featurePlan = featurePlan;
  }
};

const setSelectedSpaceCustomize = (state: State, payload): void => {
  const rooms = state.space?.scenario?.rooms
    ? state.space.scenario.rooms
    : null;
  state.selectedSpaceCustomize = payload;
  if (payload && payload.scenario && !payload.scenario.rooms && rooms) {
    state.space.scenario.rooms = rooms;
  }
};

const setSpaceName = (state: State, payload): void => {
  state.space.name = payload;
};

const setWelcomeText = (state: State, payload): void => {
  state.space.welcomeText = payload;
};

const setSpaceImageUpdate = (state: State, payload): void => {
  state.space.backgroundImage = payload.backgroundImage;
  state.space.boardImage = payload.boardImage;
  state.space.commonImage = payload.commonImage;
  state.space.logoImage = payload.logoImage;
};

const updateRoom = (state: State, payload): void => {
  const index = state.space.scenario.rooms.findIndex(
    (a) => a.id === payload.id
  );
  state.space.superSpace.isMultiWebinarActivated =
    payload.isMultiWebinarActivated;
  state.space.scenario.rooms.splice(index, 1, payload);
};
const updatePoster = (state: State, payload): void => {
  const index = state.space.scenario.posters.findIndex(
    (a) => a.id === payload.id
  );
  state.space.scenario.posters.splice(index, 1, payload);
};
const changeMultiWebinarInStore = (state: State, payload): void => {
  state.space.superSpace.isMultiWebinarActivated = payload;
};

const setSpacesAvailable = (state: State, payload): void => {
  state.spacesAvailable = payload.spaces;
  state.superSpace = payload.superSpace;
};

const addSpacesAvailable = (state: State, payload): void => {
  state.spacesAvailable = [...state.spacesAvailable, ...payload.spaces];
  const filter = state.spacesAvailable.filter(
    (a, index, arr) => arr.findIndex((b) => b.id === a.id) === index
  );
  state.spacesAvailable = filter;
};

const updateSpaceAvailable = (state: State, payload): void => {
  const index = state.spacesAvailable.findIndex((a) => a.id === payload.id);

  state.spacesAvailable.splice(index, 1, payload);
};
const deleteSpaceAvailable = (state: State, payload): void => {
  const index = state.spacesAvailable.findIndex((a) => a.id === payload);
  state.spacesAvailable.splice(index, 1);
};

const setUsersInSpace = (state: State, payload): void => {
  state.usersInSpace = payload;
};

const setUsersInDraw = (state: State, payload): void => {
  state.usersInDraw = payload;
};
const setTotalUsersInSpace = (state: State, payload): void => {
  state.totalUsersInSpace = payload;
};
const addUsersInSpace = (state: State, payload): void => {
  const usersInSpace = state.usersInSpace.map((a) => {
    const user = payload.filter((b) => b.id === a.id)[0];
    if (user) return user;
    return a;
  });
  const array = [...usersInSpace, ...payload];
  const filter = array.filter(
    (a, index, arr) => arr.findIndex((b) => b.id === a.id) === index
  );
  state.usersInSpace = filter;
};

const addUsersInDraw = (state: State, payload): void => {
  state.usersInDraw.push(payload);
};

const removeUsersInDraw = (state: State, payload): void => {
  const index = state.usersInDraw.findIndex((a) => a.id === payload.id);
  state.usersInDraw.splice(index, 1);
};
const setSceneTypes = (state: State, payload): void => {
  state.sceneTypes = payload;
};
const setUsersInSpacePage = (state: State, payload): void => {
  state.usersInSpacePage = payload;
};
const setLastPage = (state: State, payload): void => {
  state.lastPage = payload;
};
const setAllUsers = (state: State, payload): void => {
  state.allUsers = payload;
};

const setSpacesAvailablePage = (state: State, payload): void => {
  state.spacesAvailablePage = payload;
};

const setLastPageSpaces = (state: State, payload): void => {
  state.lastPageSpaces = payload;
};

const setFavouriteSpaces = (state: State, payload): void => {
  state.favouriteSpaces = payload;
};

const setConnectedSuperSpaceIds = (state: State, payload): void => {
  state.connectedSuperSpaceIds = payload;
};

const setConnectedUsersCounter = (state: State, payload): void => {
  state.connectedUsersCounter = payload;
};

export default {
  setSpace,
  setSpacesAvailable,
  addUsersInSpace,
  setSceneTypes,
  setUsersInSpacePage,
  setLastPage,
  setAllUsers,
  setUsersInSpace,
  setSpaceName,
  setWelcomeText,
  setSpaceImageUpdate,
  addSpacesAvailable,
  setSpacesAvailablePage,
  setLastPageSpaces,
  updateRoom,
  deleteSpaceAvailable,
  updateSpaceAvailable,
  setTotalUsersInSpace,
  changeMultiWebinarInStore,
  updatePoster,
  addUsersInDraw,
  removeUsersInDraw,
  setUsersInDraw,
  setFavouriteSpaces,
  setSelectedSpaceCustomize,
  setConnectedSuperSpaceIds,
  setConnectedUsersCounter,
};
